<h2 mat-dialog-title class="sk-dialog-title"><mat-icon>table_view</mat-icon> Excel exportieren</h2>

<mat-dialog-content class="dialog-content">
  <p class="sk-muted intro" *ngIf="data.auftragTitel">
    Regie-Abrechnung „{{ data.auftragTitel }}“ – bitte die Exportvariante wählen.
  </p>

  <mat-radio-group class="auswahl" [(ngModel)]="modus" (change)="auswahlGeaendert()" [disabled]="exportLaeuft"
    aria-label="Exportvariante">
    <mat-radio-button value="gesamt" class="auswahl-option">
      <span class="option-text">
        <strong>Excel Gesamt</strong>
        <span class="sk-muted">Alle Materialien und Stunden des gesamten Auftrags in einem Tabellenblatt.</span>
      </span>
    </mat-radio-button>

    <mat-radio-button value="einsaetze" class="auswahl-option">
      <span class="option-text">
        <strong>Excel nach Einsatz</strong>
        <span class="sk-muted">Ein Tabellenblatt pro Einsatz mit den jeweiligen Materialien und Stunden.</span>
      </span>
    </mat-radio-button>
  </mat-radio-group>

  <!-- Status der Einsätze – nur relevant für „Excel nach Einsatz“ -->
  <div class="unterauswahl" *ngIf="modus === 'einsaetze' && (einsaetzeLaden || einsaetzeFehler || keineEinsaetze)">
    <div class="sk-loading einsaetze-laden" *ngIf="einsaetzeLaden">
      <mat-spinner diameter="26"></mat-spinner>
      <span class="sk-muted">Einsätze werden geladen …</span>
    </div>

    <p class="hinweis fehler" *ngIf="einsaetzeFehler">
      <mat-icon>error_outline</mat-icon> {{ einsaetzeFehler }}
    </p>

    <p class="hinweis" *ngIf="keineEinsaetze">
      <mat-icon>info_outline</mat-icon>
      Für dieses Projekt sind keine Einsätze mit abgerechneten Stunden oder Material vorhanden.
    </p>
  </div>

  <p class="hinweis fehler" *ngIf="fehler">
    <mat-icon>error_outline</mat-icon> {{ fehler }}
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="abbrechen()" [disabled]="exportLaeuft">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="exportieren()" [disabled]="!kannExportieren">
    <mat-spinner *ngIf="exportLaeuft" diameter="18"></mat-spinner>
    <mat-icon *ngIf="!exportLaeuft">download</mat-icon>
    {{ exportLaeuft ? 'Wird erstellt …' : 'Exportieren' }}
  </button>
</mat-dialog-actions>
